import { IonApp, isPlatform, setupIonicReact } from '@ionic/react';
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter } from 'react-router-dom';

import { UserContextProvider } from './context/user-context';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';

import PageRoot from './pages/PageRoot';
import { useEffect } from 'react';

import './ionicImports';
import './stylingImports';

setupIonicReact();

const queryClient = new QueryClient({
   defaultOptions: {
      queries: {
         refetchOnWindowFocus: false,
         refetchOnMount: true,
         refetchOnReconnect: true,
         retry: false,
      },
   },
});
const App = () => {
   useEffect(() => {
      if (isPlatform('ios') || isPlatform('android')) {
         SplashScreen.hide();
         ScreenOrientation.lock('portrait').catch(() => {});
         StatusBar.setStyle({ style: Style.Light }).catch(() => {});
      }
   }, []);

   return (
      <BrowserRouter>
         <QueryClientProvider client={queryClient}>
            <IonApp>
               <UserContextProvider>
                  <PageRoot />
               </UserContextProvider>
            </IonApp>
            <ReactQueryDevtools initialIsOpen={false} />
         </QueryClientProvider>
      </BrowserRouter>
   );
};

export default App;
